import { useState, useEffect } from "react";
import { parseJwt } from "helpers";
import { getUser, login, refreshLogin } from "services/users";

export default function useFindUser() {
  const [user, setUser] = useState(null);
  const [userId, setUserId] = useState(null);
  const [role, setRole] = useState(null);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    async function findUser() {
      const userLoggedIn = getUser();

      if (userLoggedIn && userLoggedIn.token) {
        const jwt = parseJwt(userLoggedIn.token);
        setUserId(jwt.id);
        setRole(jwt.roles[0]);
        setUser(userLoggedIn);
        setLoading(false);
      } else {
        setLoading(false);
      }
    }
    findUser();
  }, []);

  async function loginUser(email, password) {
    setLoading(true);
    const response = await login(email, password);

    if (response) {
      const jwt = parseJwt(response.token);
      setUserId(jwt.id);
      setRole(jwt.roles[0]);
      setUser(response);
      setLoading(false);
    } else {
      setLoading(false);
    }
    return new Promise((resolve, reject) => {
      resolve(response);
    });
  }

  async function refreshUser() {
    setLoading(true);
    let response = await refreshLogin();
    if (response) {
      const jwt = parseJwt(response.token);
      setUserId(jwt.id);
      setRole(jwt.roles[0]);
      setUser(response);
      setLoading(false);
    } else {
      setLoading(false);
    }
  }

  return {
    user,
    setUser,
    loginUser,
    refreshUser,
    isLoading,
    userId,
    role,
  };
}
